import { useParams, useNavigate } from "react-router-dom";
import { EditBillPage as EditBillPageView } from "@/components/EditBillPage";

export function EditBillPage() {
  const { billId } = useParams<{ billId: string }>();
  const navigate = useNavigate();

  if (!billId) return null;

  return (
    <EditBillPageView
      billId={billId}
      onSaved={(id) => navigate(`/bills/${id}`)}
      onCancel={() => navigate(`/bills/${billId}`)}
      onSupplierClick={(supplierId) => navigate(`/suppliers/${supplierId}`)}
    />
  );
}
